import { setSingleTicket, setTickets, setTicketsCurrentpage, setTicketsTotalDocs, setTicketsTotalPages } from "redux/actions/Tickets";
import { fetchError, fetchStart, fetchSuccess } from "../../redux/actions";

import axios from "../auth/jwt/config";

const TicketRequests = {
    getAllTickets: (page,status) => {
        return (dispatch) => {
            try {
                dispatch(fetchStart());
                axios
                    .get(`/support/ticket/getall?page=${page}&limit=5&status=${status}`)
                    .then(({ data }) => {
                        dispatch(fetchSuccess());
                        dispatch(setTickets(data.docs));
                        dispatch(setTicketsCurrentpage(data.page));
                        dispatch(setTicketsTotalPages(data.totalPages));
                        dispatch(setTicketsTotalDocs(data.totalDocs))
                    })
                    .catch((error) => {
                        if (error.response) {
                            dispatch(fetchError(error.response.data.msg));
                        } else {
                            dispatch(fetchError(error.message));
                        }
                    });
            } catch (error) {
                dispatch(fetchError(error.message));
            }
        };
    },
    getTicketById: (id) => {
        return (dispatch) => {
            try {
                dispatch(fetchStart());
                axios
                    .get(`/support/ticket/getbyid/${id}`)
                    .then(({ data }) => {
                        dispatch(fetchSuccess());
                        dispatch(setSingleTicket(data))
                    })
                    .catch((error) => {
                        if (error.response) {
                            dispatch(fetchError(error.response.data.msg));
                        } else {
                            dispatch(fetchError(error.message));
                        }
                    });
            } catch (error) {
                dispatch(fetchError(error.message));
            }
        };
    },
    updateTicketStatus: (id,status)=>{
        return(dispatch)=>{
            try {
                dispatch(fetchStart());
                axios
                    .patch(`/support/ticket/update/${id}`,{
                        "status": status 
                    })
                    .then(({ data }) => {
                        dispatch(fetchSuccess("با موفقیت به روزرسانی شد"));
                        dispatch(setSingleTicket(data))
                    })
                    .catch((error) => {
                        if (error.response) {
                            dispatch(fetchError(error.response.data.msg));
                        } else {
                            dispatch(fetchError(error.message));
                        }
                    });
            } catch (error) {
                dispatch(fetchError(error.message));
            }
        }
    }
};

export default TicketRequests;